import { createBrowserRouter, Navigate } from "react-router";
import { lazy } from "react";
import { AuthProvider } from "./contexts/AuthProvider";
import { SettingsProvider } from "./contexts/SettingsProvider";
import { AuthGuard } from "./components/AuthGuard";

const ErrorBoundary = lazy(() =>
  import("./components/ErrorBoundary").then(({ ErrorBoundary }) => ({
    default: ErrorBoundary,
  }))
);

const Home = lazy(() =>
  import("./pages/Home").then(({ Home }) => ({
    default: Home,
  }))
);

const ApiKey = lazy(() =>
  import("./pages/ApiKey").then(({ ApiKey }) => ({
    default: ApiKey,
  }))
);

const CampaignDetail = lazy(() =>
  import("./pages/CampaignDetail").then(({ CampaignDetail }) => ({
    default: CampaignDetail,
  }))
);

const CommentAnalysis = lazy(() =>
  import("./pages/CommentAnalysis").then(({ CommentAnalysis }) => ({
    default: CommentAnalysis,
  }))
);

const CommentAnalysisHome = lazy(() =>
  import("./pages/CommentAnalysisHome").then(({ CommentAnalysisHome }) => ({
    default: CommentAnalysisHome,
  }))
);

const router = createBrowserRouter([
  {
    element: (
      <AuthProvider>
        <SettingsProvider>
          <AuthGuard />
        </SettingsProvider>
      </AuthProvider>
    ),
    errorElement: <ErrorBoundary />,
    children: [
      { path: "/", Component: Home },
      { path: "/api-key", Component: ApiKey },
      { path: "/campaigns/:campaignId", Component: CampaignDetail },
      { path: "/comment-analysis", Component: CommentAnalysisHome },
      { path: "/comment-analysis/:campaignId", Component: CommentAnalysis },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);

export { router };
